<template>
    <div>
        <div v-if="$root.user.active">
            {{ status }}
            <div class="row setting row-last explanation">
                <div>
                    Dit is het overzicht van al jouw facturen. Vanuit dit scherm kun je een factuur versturen naar je emailadres.
                </div>
            </div>
            <div class="row head">
                <div class="col col-100">Facturen</div>
            </div>
            <div class="row setting finance row-list-item" v-for="(item, index) in invoices">

                <div class="col col-70">

                    <div class="account-info__title">{{ item.updateDate }}</div>
                    <div class="account-info__subtitle">
                      <p>Factuurnummer: {{ item.number }}</p>
                    </div>
                    <div class="account-info__subtitle" v-if="item.prepaid == true"  >
                        <p>{{ item.priceVat }} incl. BTW</p>
                    </div>
                    <div class="account-info__subtitle" v-else >
                        <p>{{ item.price }} excl. BTW <br><span class="account-info__vat">{{ item.priceVat }} incl. BTW</span></p>
                    </div>
                </div>
                <div class="col col-30">
                    <div class="row">
                        <div class="col col-50" @click="export_data('Factuur ' + item.number, item.id)">
                            <img src="@/assets/images/send-invoice.svg">
                        </div>
                        <!-- <div class="col col-50" @click="export_data_2(item.id)">
                            <img src="@/assets/images/download-invoice.svg">
                        </div> -->
                    </div>
                </div>
            </div>
            
        </div>
        <div class="row spacer">&nbsp;</div>
    </div>
</template>

<script>
    export default {
    name: 'Invoices',
        data () {

            return {
                invoices: [],
                user: {},
                status: '',
            }
        },

        mounted(){


        },

        created(){

            this.getInvoices();
            this.getUserData();
        },

        methods:{

            getInvoices(){

                this.$api.get('/invoices')
                .then(response => {

                    this.invoices = response.data;
                })
                .catch(e => {

                })
            },

            getUserData(){
                this.$api.get('/dashboard')
                .then(response => {
                    this.user = response.data.user;
                    root.loading = false;
                })
                .catch(e => {

                })
            },

            export_data_2: function(id){

                var root = this.$root;
                var _this = this;

                root.loading = true;

                this.$api.post('/download/prepare', {
                    service: 'account/invoice',
                    meta: id
                })
                .then(response => {
                    console.log(response.data)
                    //  _this.$root.ui.showDialog(
                    //     'Voltooid',
                    //     'De factuur wordt gedownload.',
                    //     true
                    // );
                    // const linkSource = `data:application/pdf;base64,${response.data.pdf.pdfContents}`;

                    let linkSource = response.data.pdf.pdfUrl.replace('dev.api', 'r');

                    linkSource = linkSource.replace('s/export', '');
                    this.status = 'de link source is ' + linkSource;
                    console.log(this.status);
                    // const downloadLink = document.createElement("a");
                    // const fileName = response.data.pdf.pdfName;;
                    // downloadLink.href = linkSource;

                    // downloadLink.download = fileName;
                    console.log('Log net voor de redirect');
                    this.status += 'Log net voor de redirect';
                    document.location = linkSource;

                    this.status += ' dit is log na de redirect';
                    console.log('dit is log na de redirect');
                    root.loading = false;
                })
                .catch(e => {

                    root.loading = false;

                    _this.$root.ui.showDialog(
                        'Fout',
                        'Gegevens konden niet worden opgehaald.',
                        true
                    );
                })
            },

            export_data: function(title, id){

                var root = this.$root;
                var _this = this;

                _this.$root.ui.showDialog(
                    title,
                    'Wil je deze factuur naar het volgende facturatie emailadres sturen? <br><br>' +
                    '<div class="row setting"><input id="email" value=' + this.user.email + ' placeholder="E-mail"></input></div>',

                    false,
                    {
                        0:{
                            name: 'Versturen',
                            execute: function(){

                                root.loading = true;

                                _this.$api.post('/download/prepare', {
                                    service: 'invoices/export',
                                    email: document.getElementById('email').value,
                                    meta: id
                                })
                                .then(response => {

                                    root.loading = false;
                                    _this.$root.ui.showDialog(
                                        'Voltooid',
                                        'De download link om de factuur te downloaden is verstuurd naar jouw emailadres.',
                                        true
                                    );
                                    // I commented this out, since the api doesn't return a schedule, im not sure what is was used for. Check later if this can be deleted.
                                    // _this.data.schedule = response.data.schedule;
                                })
                                .catch(e => {

                                    root.loading = false;

                                    _this.$root.ui.showDialog(
                                        'Fout',
                                        e.response.data.message,
                                        true
                                    );
                                })
                            }
                        },
                        1:{
                            name: 'Annuleren',
                            execute: function(){}
                        }
                    }
                );


                /*
                this.$api.post('/download/prepare', {
                    service: 'invoices/export',
                    meta: id
                })
                .then(response => {

                    _this.$root.ui.showDialog(
                        title,
                        'Wil je deze factuur naar het facturatie emailadres sturen?',
                        true,
                        {
                            0: {
                                name: 'Verzenden',
                                action: response.data.url,
                                execute: function(){}
                            }
                        }
                    );
                })
                .catch(e => {

                    _this.$root.ui.showDialog(
                        'Fout',
                        'Gegevens konden niet worden opgehaald.',
                        true
                    );
                })
                */
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Invoices.vue